export const INSPECTION_REQUIREMENTS = {
  STANDARD: {display: 'Standard', value: 'Standard', showOrder: 0, def: true},
  VIRTUAL: {display: 'Virtual with iPermit', value: 'Virtual', showOrder: 1, def: false},
  VIRTUAL_WITH_CONTRACTOR: {display: 'Virtual with Contractor', value: 'Virtual with contractor', showOrder: 2, def: false},
  CONTRACTOR_ONSITE: {display: 'Contractor on site', value: 'Contractor on site', showOrder: 3, def: false},
};


